import { memo } from "react";
import { Skeleton } from "@/core/components/ui/skeleton";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { useGetActivityCustomer } from "@/activity-feed/query";
import { formatPhoneNumber } from "@/core/utils/phone";
import { getCustomerNameOrPhone } from "@/customer/utils";
import { SPIFF_RULE_EVENTS } from "@/spiff-rules/constants";
import { DetailCard, InfoPair } from "./common";

interface CustomerDetailCardProps {
  customerId: string;
  inView: boolean;
}

export const CustomerDetailCard = memo(
  ({ customerId, inView }: CustomerDetailCardProps) => {
    const { data: customer, isLoading } = useGetActivityCustomer(
      customerId,
      inView,
    );

    // Show loading only if we don't have data yet
    if (!customer && (!inView || isLoading)) {
      return (
        <DetailCard eventType={SPIFF_RULE_EVENTS.signup}>
          <Stack gap="sm" fullWidth>
            <Skeleton className="h-5 w-48" />
            <Skeleton className="h-4 w-40" />
          </Stack>
        </DetailCard>
      );
    }

    if (!customer) {
      return (
        <DetailCard eventType={SPIFF_RULE_EVENTS.signup}>
          <Stack gap="sm" fullWidth>
            <Typography variant="bodyW2" className="font-semibold">
              Customer Details
            </Typography>
            <Typography variant="bodyW3" textColor="secondary">
              Customer information unavailable
            </Typography>
          </Stack>
        </DetailCard>
      );
    }

    return (
      <DetailCard eventType={SPIFF_RULE_EVENTS.signup}>
        <Stack gap="xs" fullWidth>
          <Typography variant="subtitleW2">
            {getCustomerNameOrPhone(customer)}
          </Typography>
          <InfoPair
            label="Phone"
            value={formatPhoneNumber(customer.phone_number)}
          />
        </Stack>
      </DetailCard>
    );
  },
);
